import React, { useMemo, useState } from 'react'
import { PageProps } from 'gatsby'
import { useCustomers } from 'lib/hooks'
import {
  CustomerQueryInput,
  CustomerType,
  UnregisteredCustomersQueryVariables,
} from 'lib/graphql/storeadmin'
import { Card, Pagination, Space, Title, Error } from 'components/common'
import { CustomerSearch, CustomersTable } from 'components/customers'
import { datetime } from 'lib/str-formatter'
import { customerTypeInput } from 'lib/constants'

type UnregisterCustomerDataSourceType = {
  key: string | number | boolean
  email: string
  createdAt: string
}

const IndexPage = (props: PageProps<Queries.Query>): JSX.Element => {
  // Search（検索条件）
  const [warning, setWarning] = useState<string>(null)
  const [queryVariables, setQueryVariables] =
    useState<UnregisteredCustomersQueryVariables>({
      input: [],
    })

  // Pagination & Data Source
  const { data, loading, error, goto, page, size, total, paginate } =
    useCustomers({
      type: CustomerType.Unregistered,
      initialSize: 10,
      queryOptions: { variables: queryVariables },
    })

  const dataSource = useMemo<UnregisterCustomerDataSourceType[]>(() => {
    return data?.reduce(
      (result: UnregisterCustomerDataSourceType[], customer) => {
        result.push({
          key: customer.key.toString(),
          email: customer.email,
          createdAt: datetime(customer.createdAt),
        })
        // console.log(result)
        return result
      },
      []
    )
  }, [data])

  // 検索機能
  const onSearch = (searchField: string, input: CustomerQueryInput) => {
    if (!searchField) {
      setWarning('絞り込むメールアドレスを入力してください')
      return
    }
    goto(1)
    setWarning(null)
    setQueryVariables({
      input: [
        input,
        { ...customerTypeInput, value: CustomerType.Unregistered },
      ],
    })
  }

  // 検索解除
  const onSearchClear = () => {
    if (data?.length > 0) {
      goto(1)
    }
    setWarning(null)
    setQueryVariables(null)
  }

  if (error) {
    return Error.render(error)
  }

  return (
    <>
      <Title level={1}>顧客（利用情報未登録）管理</Title>
      <Card shadow>
        {warning && <div className="ml-2 text-red-600">{warning}</div>}

        <CustomerSearch
          onSearchBack={onSearch}
          searchClear={onSearchClear}
          selectOptions={{ email: 'メールアドレス' }}
          placeholder="メールアドレスで絞り込む"
          defaultValue="email"
        />

        <Space direction="vertical" size="large">
          <CustomersTable
            customerType={CustomerType.Unregistered}
            dataSource={dataSource}
            loading={loading}
          />
          <Pagination
            current={page}
            pageSize={size}
            total={total}
            onChange={paginate}
            showSizeChanger
          />
        </Space>
      </Card>
    </>
  )
}

export default IndexPage
